export default function comparisonSlider({main, on, elm}) {
    main(() => {
        // setAspectRatio(1);
        // setAspectRatio(2);

        on('input', '.comparison__slider', changePosition);
    });

    const changePosition = function(e) {
        elm.style.setProperty('--position', e.target.value + '%');
    };

    // const setAspectRatio = function (imageNumber) {
    //     const imageElement = document.querySelector(`.comparison__image--${imageNumber}`);
    //     const aspectRatio = imageElement.naturalWidth / imageElement.naturalHeight;
    //     const aspectRatioString = aspectRatio.toString();
    //     document.querySelector('.comparison__images')
    //         .style.setProperty('--aspect-ratio', aspectRatioString);
    // };
};

export const model = {};
